/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["agm-map[_ngcontent-%COMP%] {\n  height: 300px; }\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92YXIvamVua2luc19ob21lL3dvcmtzcGFjZS9CbHVlYmVlIEZyb250ZW5kL3NyYy9hcHAvcGFnZXMvd2l0aG91dC1sb2dpbi92aWV3LW1kci9nZW9sb2NhdGlvbi9nZW9sb2NhdGlvbi5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQTtFQUNFLGFBQWEsRUFBQSIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL3dpdGhvdXQtbG9naW4vdmlldy1tZHIvZ2VvbG9jYXRpb24vZ2VvbG9jYXRpb24uY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyJcbmFnbS1tYXAge1xuICBoZWlnaHQ6IDMwMHB4O1xufVxuIl19 */"];
export { styles as styles };
